import React from "react"
import { formatInternationalPhone } from "../../../utlis/summaryhelpers"

const MarketingTable = ({
  inquiries,
  onView,
  loading = false,
  error = "",
}) => {
  return (
    <>
      {/* Desktop Table View - Hide on mobile */}
      <div className="hidden md:block overflow-x-auto rounded-lg border border-gray-300 shadow-sm">
        <table className="w-full min-w-full table-auto">
          <thead>
            <tr className="bg-[#005787] text-left text-sm md:text-base text-white">
              <th className="p-3 md:p-4 font-medium">Last Contacted</th>
              <th className="p-3 md:p-4 font-medium w-[150px]">Name</th>
              <th className="p-3 md:p-4 font-medium w-[150px]">Location</th>
              <th className="p-3 md:p-4 font-medium ">Visa Type</th>
              <th className="p-3 md:p-4 font-medium">Phone</th>
              <th className="p-3 md:p-4 font-medium w-[150px]">Email</th>
              <th className="p-3 md:p-4 font-medium">Form Summary</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {loading ? (
              <tr>
                <td colSpan="7" className="p-8 text-center text-gray-500">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" className="p-8 text-center text-red-600">{error}</td>
              </tr>
            ) : inquiries.length > 0 ? (
              inquiries.map((inquiry, index) => (
                <tr
                  key={inquiry.id}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition-colors`}
                >
                  <td className="p-3 md:p-4 text-sm">{inquiry.lastContacted}</td>
                  <td className="p-3 md:p-4 text-sm font-medium">
                    <div className="max-w-[150px] truncate">{inquiry.name}</div>
                  </td>
                  <td className="p-3 md:p-4 text-sm">
                    <div className="max-w-[150px] truncate">{inquiry.location}</div>
                  </td>
                  <td className="p-3 md:p-4 text-sm ">{inquiry.visaType}</td>
                  <td className="p-3 md:p-4 text-sm">{formatInternationalPhone(inquiry.phone)}</td>
                  <td className="p-3 md:p-4 text-sm">
                    <div className="max-w-[150px] truncate">{inquiry.email}</div>
                  </td>
                  <td className="p-3 md:p-4">
                    <button onClick={() => onView?.(inquiry)} className="bg-[#005787] text-white px-4 py-1.5 rounded-full text-sm hover:bg-[#004567] transition-colors">
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="p-8 text-center text-gray-500">
                  No inquiries found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile Responsive Cards View - Show only on small screens */}
      <div className="md:hidden rounded-lg border border-gray-300 shadow-sm overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-gray-500">Loading...</div>
        ) : error ? (
          <div className="p-8 text-center text-red-600">{error}</div>
        ) : inquiries.length > 0 ? (
          <div className="divide-y divide-gray-200">
            {inquiries.map((inquiry) => (
              <div key={inquiry.id} className="p-4 bg-white hover:bg-gray-50 transition-colors">
                <div className="space-y-3">
                  <div className="flex justify-between items-start gap-2">
                    <div className="flex-1 min-w-0">
                      <p className="font-medium text-gray-900 truncate">{inquiry.name}</p>
                      <p className="text-xs text-gray-500 truncate">{inquiry.location}</p>
                    </div>
                    <button onClick={() => onView?.(inquiry)} className="bg-[#005787] text-white px-3 py-1.5 rounded-full text-xs whitespace-nowrap hover:bg-[#004567] transition-colors">
                      View
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-2 text-xs md:text-sm">
                    <div>
                      <p className="text-gray-500 font-medium">Last Contacted</p>
                      <p className="font-semibold text-gray-900">{inquiry.lastContacted}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium">Visa Type</p>
                      <p className="font-semibold text-gray-900 truncate">{inquiry.visaType}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium">Phone</p>
                      <p className="font-semibold text-gray-900 truncate">{formatInternationalPhone(inquiry.phone)}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 font-medium">Email</p>
                      <p className="font-semibold text-gray-900 truncate text-[10px] md:text-xs">{inquiry.email}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="p-8 text-center text-gray-500">No inquiries found</div>
        )}
      </div>
    </>
  )
}

export default MarketingTable

